/**
 * Get a slide offset by adding slides widths until reaching the given slide index
 * If dx is below 0, it means we are in loop mode, and the positions of the slides are reversed
 * @param widths [Array<Number>] Array of widths of the slides
 * @param index [Int] Index of a given slide to get the offset from
 * @param dx [-1 | 1] Direction to know if we need to add the slides widths or to subtract them
 * @returns [Number] Offset of the given slide
 */
export const getWidthToOffset = (widths, index, dx = 1) => {
	return widths.reduce((acc, width, id) => {
		// Add/Substract slides widths until reaching the beginning of the given slide index
		if (id < index) dx < 0 ? (acc -= width) : (acc += width);

		return acc;
	}, 0);
};
